module.exports = __webpack_public_path__ + "static/media/giphy.b71b7d60.gif";